'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import Select from 'react-select';
import Modal from 'react-modal';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersOperations, ordersSelectors } from '@/state/domains/orders';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ServeDetails from '@/views/common/ServeDetails';
import Attempts from '../Attempts'; 

import s from '../styles.scss';
import m from '@/views/pages/user/Modal/styles.scss';

const sx = cn.bind(s);

class ServePage extends React.Component {

	constructor() {

		super();

		this.state = {
			tab: 'overview',
			undoModal: false
		};
	}

	render() {

		const {
			username,
			date,
			job,
			location,
			getUserById,
			serveAttempt,
			canEdit,
			setModalOpen,
		} = this.props;

		if (!serveAttempt) {
			return <div />;
		}

		const { tab, undoModal } = this.state;
		const servedBy = getUserById(serveAttempt.userId);

		return (
			<div className={ s.complete }>
				<div className={ s.servePageActions }>
					<button
						className={ sx({ active: tab === 'overview' }) }
						onClick={ () => this.setState({ tab: 'overview' }) }
					>
						Overview
					</button>
					<button
						className={ sx({ active: tab === 'details' }) }
						onClick={ () => this.setState({ tab: 'details' }) }
					>
						Details
					</button>
					<button
						className={ sx({ active: tab === 'attempts' }) }
						onClick={ () => this.setState({ tab: 'attempts' }) }
					>
						Attempts
					</button>
					{ canEdit && (
						<button onClick={
							() => setModalOpen('undoComplete', { type: 'serve', username, date }) 
						}>
							<FontAwesomeIcon icon='undo-alt' color='#888'/>
						</button>
					)}
				</div>
				{ tab === 'overview' && <div className={ s.details }>
					<div className={ s.icon }>
						<FontAwesomeIcon icon={ [ 'far', 'check-circle' ] } color='#2686d8' />
					</div>
					<div className={ s.type }>Served</div>
					<div className={ s.metadata }>
						<div className={ sx('metadataRow', 'filler') }>on</div>
						<div className={ s.metadataRow }>
							{ format(new Date(serveAttempt.date), 'MMMM do yyyy, h:mm aaa') }
						</div>
						<div className={ sx('metadataRow', 'filler') }>by</div>
						<div className={ s.metadataRow }>{ servedBy.username }</div>
						<div className={ sx('metadataRow', 'filler') }>at</div>
						<div className={ s.metadataRow }>
							<FontAwesomeIcon icon='map-marker-alt' color='#999'/>
							<span className={ s.geo }>
								{ serveAttempt.geo && serveAttempt.geo.length ?
									`( ${ serveAttempt.geo[0].toFixed(4) }, ${ serveAttempt.geo[1].toFixed(4) } )` :
									'?'
								}
							</span>
						</div>
						<br />
					</div>
				</div>}
				{ tab === 'details' && <ServeDetails { ...serveAttempt.details } /> }
				{ tab === 'attempts' && <Attempts job={ job } location={ location } /> }
			</div>
		);
	}
}

export default connect(
	(state, props) => ({
		date: appSelectors.getPageDate(state, props),
		username: usersSelectors.getUsername(state, props),
		serveAttempt: attemptsSelectors.getServeAttempt(state, props),
		getUserById: id => usersSelectors.getUserById(state, props)(id),
	}),
	{
		setModalOpen: appOperations.setModalOpen,
	}
)(ServePage);
